import { parse, isOperatorNode, isParenthesisNode, MathNode } from "mathjs";

const functionMap: Record<string, string> = {
  add: "SUM",
  subtract: "SUBTRACT",
  multiply: "MULTIPLY",
  divide: "DIVIDE",
};

function collectOperands(node: MathNode, operatorFn: string): MathNode[] {
  if (
    isOperatorNode(node) &&
    node.fn === operatorFn &&
    node.args.length === 2
  ) {
    return node.args.flatMap((arg) => collectOperands(arg, operatorFn));
  }

  return [node];
}

function toFunctionStyle(node: MathNode): string {
  if (isParenthesisNode(node)) {
    // the AST already encodes precedence, so the parentheses can be dropped
    return toFunctionStyle(node.content);
  }

  if (isOperatorNode(node)) {
    const fnName = functionMap[node.fn];

    if (!fnName) {
      return `${node.op}${node.args.map(toFunctionStyle).join(", ")}`;
    }

    // Flatten only consecutive operators of the same type.
    const operands = collectOperands(node, node.fn);

    return `${fnName}(${operands.map(toFunctionStyle).join(", ")})`;
  }

  // SymbolNode (A1), ConstantNode (10), etc.
  return node.toString();
}

export function convertFormula(formula: string): string {
  try {
    return toFunctionStyle(parse(formula));
  } catch (error) {
    console.error(error);
    return "";
  }
}

declare global {
  interface Window {
    convertFormula: typeof convertFormula;
  }
}

window.convertFormula = convertFormula;
